"use client";

import { useEffect } from "react";
import TokensContent from "@/components/TokensContent";

interface TokensPanelProps {
  open: boolean;
  onClose: () => void;
  // Which edge to anchor to — matches the pill that opened it. Defaults right.
  side?: "left" | "right";
}

// Compact in-place tokens panel that drops down over the wheel — same treatment
// as the leaderboard, so buying/checking tokens never navigates away from the
// run. Anchors to the same edge as the pill that opened it.
export default function TokensPanel({
  open,
  onClose,
  side = "right",
}: TokensPanelProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={`animate-slide-down fixed top-16 z-50 flex max-h-[min(80vh,38rem)] w-[min(92vw,22rem)] flex-col overflow-hidden rounded-2xl border border-accent/40 bg-background/95 shadow-[0_0_50px_rgba(0,0,0,0.7)] backdrop-blur ${
        side === "left" ? "left-4" : "right-4"
      }`}
    >
      <div className="flex shrink-0 items-center justify-between border-b border-white/10 px-4 py-3">
        <h3 className="text-sm font-extrabold uppercase tracking-widest text-white">
          Get Tokens
        </h3>
        <button
          onClick={onClose}
          aria-label="Close tokens"
          className="flex h-7 w-7 items-center justify-center rounded-full border border-white/20 text-white/60 transition hover:border-accent hover:text-accent"
        >
          ✕
        </button>
      </div>
      <div className="overflow-y-auto p-4">
        <TokensContent compact />
      </div>
    </div>
  );
}
